import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchAllOnMailPayers } from '../../../store/actions/lookUpAction';
import { MAILBOX_ROUTE } from '../../../config/route/NestedRoutesConfig';
import NestedRoute from '../../../shared/components/tabs/NestedRoute';
import { getMappedRoute } from '../../../utils/routeUtility';
import CommonTab from '../../../shared/components/tabs/CommonTab';
import ApplicationDetail from '../../../shared/services/applicationDetail.service';
import { RootState } from '../../../store';
import { MailboxType } from '../../../store/models/mailBoxModel';
import GroupLoginConfiguration from './GroupLoginConfiguration';
import { CenterContext } from '../../crm/inPatient/newAdmission/CenterContext';

const Mailbox = ({match, location}: any): ReactElement => {
  const dispatch = useDispatch();
  const appDetail = ApplicationDetail.instance;
  const groupProviders = appDetail?.getGroupProviders();
  const { centerId } = useSelector((state: RootState): MailboxType => state?.mailBox || {});
  useEffect((): any => {
    dispatch(fetchAllOnMailPayers());
  }, []);
  const nextDefaultPage = getMappedRoute(location?.pathname, MAILBOX_ROUTE) || MAILBOX_ROUTE[0].routeName;
  return (
    <>
      <CenterContext.Provider value={{ center: centerId }} >
        {groupProviders?.length !== 0 && <GroupLoginConfiguration />}
        <NestedRoute
          match={match}
          defaultPage={nextDefaultPage}
          nestedNav={MAILBOX_ROUTE}
          isWidthFull={true}
          centerId={centerId}
          isGrpLogin={groupProviders?.length ? true : false}
          commonComponent={CommonTab} />
      </CenterContext.Provider>
    </>
  );
};
export default Mailbox;
